import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import classes from "./index.module.css";
import ManufacturerReportFilter from "./ManufacturerReportFilter";
import ManufacturerReportSummary from "./ManufacturerReportSummary";
import AddManufacturer from "./addManufacturer/index";

const Manufacturer = () => {
  const [showAddManufacturer, setShowAddManufacturer] = useState(false);
  const [manufacturerData, setManufacturerData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();

  const addManufacturer = useCallback((isEdit = false) => {
    if (isEdit) {
      const data = reportRef.current.getCurrentRowData();
      setManufacturerData(data);
    }
    setShowAddManufacturer(true);
  }, []);

  const closeManufacturerAc = useCallback(() => {
    setShowAddManufacturer(false);
    setManufacturerData(null);
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  const debounceCloseManufacturerAc = _.debounce(closeManufacturerAc, 200);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        setRefreshData(true);
        return;
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (altKey && key === "m") {
        return addManufacturer();
      }
    },
    [addManufacturer, currentRowData]
  );

  const applyFilterHandler = useCallback((params, filterStates) => {
    setRefreshData(false);
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addManufacturer(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addManufacturer, currentRowData]);
  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);
    }
  }, [refreshData]);
  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddManufacturer &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [
    currentComponent,
    listener,
    onColumnShow,
    onFilterShow,
    showAddManufacturer,
  ]);
  return (
    <div className={classes["manufacturer-report-container"]}>
      <Reports
        identifier="manufacturer"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        filterStates={filterStates}
        filterParams={filterParams}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filters={
          <ManufacturerReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            refreshData={refreshData}
            onFilterShow={onFilterShow}
            applyFilters={applyFilterHandler}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <ManufacturerReportSummary
        refreshData={() => {
          setRefreshData(true);
        }}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addManufacturer();
        }}
      />
      <Autocomplete
        show={showAddManufacturer}
        height="50%"
        width="50%"
        closeAutoComplete={debounceCloseManufacturerAc}
      >
        <AddManufacturer
          manufacturerData={manufacturerData}
          onEscape={debounceCloseManufacturerAc}
          onSaveManufacturer={() => {
            debounceCloseManufacturerAc();
            setRefreshData(true);
          }}
        />
      </Autocomplete>
    </div>
  );
};

export default Manufacturer;
